$('.hide-pro-welcome-text').on('click',function(){
    Do.Ajax('/preferences/api/event',{
        handle:'hideProWelcomeText'
    });
    $('.pro-welcome-text').hide('slow');
});

$('.hide-pro-welcome-video').on('click',function(){
    Do.Ajax('/preferences/api/event',{
        handle:'hideProWelcomeVideo'
    });
    $('.pro-welcome-video').hide('slow');
});